import _ from 'underscore';
import { IPropSchema } from './types';

const defaultValues = {
  integer: 0,
  number: undefined,
  string: '',
  boolean: false,
  object: {},
  array: [],
  datetime: {},
};

/**
 * get default value for property
 * @param {IPropSchema} prop - property define, it's from schema
 * @returns {any} - return default value for different type
 */
export function getDefaultValue(prop: IPropSchema): any {
  if (_.has(prop, 'default')) {
    return prop.default;
  }

  if (!_.isEmpty(prop.enum)) {
    return prop.nullable ? null : _.first(prop.enum);
  }

  return _.clone(defaultValues[prop.type]);
}
